"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7012],{

/***/ 86525:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _useMinicart2 = __webpack_require__(34698);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _router = __webpack_require__(53746);
var __jsx = _react["default"].createElement;
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.347 20.838l-15-15 .848-.848 15 15-.848.848z",
    fill: "#2E4557"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 19.838l15-15 .848.849-15 15-.848-.849z",
    fill: "#2E4557"
  }));
};
CloseIcon.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Minicart = function Minicart(props) {
  var router = (0, _router.useRouter)();
  var children = props.children,
    button = props.button,
    checkoutButton = props.checkoutButton,
    itemsAmountInCart = props.itemsAmountInCart;
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    toggleMinicartVisibility = _useMinicart.toggleMinicartVisibility,
    isMinicartLoading = _useMinicart.isMinicartLoading;
  var translations = {
    buttonLabel: (0, _langLibrary["default"])("Go to checkout")
  };
  var orderButton = /*#__PURE__*/_react["default"].cloneElement(checkoutButton, {
    sx: {
      width: "100%",
      $rounded: true
    },
    isLoading: isMinicartLoading,
    onClick: function onClick() {
      if (isMinicartLoading) return;
      toggleMinicartVisibility();
      router.push("/checkout");
    }
  }, translations.buttonLabel);
  return __jsx(_Box["default"], {
    sx: {
      width: ["100%", null, "auto"],
      background: "white",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      position: ["fixed", null, "relative"],
      overflowY: "hidden",
      pt: 50
    }
  }, __jsx(_Box["default"], {
    sx: {
      p: "s3",
      height: 50,
      position: "fixed",
      zIndex: 2,
      bg: "white",
      top: 0,
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].cloneElement(button, {
    onClick: function onClick() {
      return toggleMinicartVisibility({
        close: true
      });
    }
  }, __jsx(CloseIcon, null))), __jsx(_Box["default"], {
    sx: {
      px: "s8",
      pt: [20, null, 0],
      pb: [100, null, 0],
      overflowY: "auto"
    }
  }, children), itemsAmountInCart > 0 && __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: 83,
      pl: "s8",
      pr: ["s8", null, null, null, "s6"],
      py: 25,
      position: ["fixed", null, "sticky"],
      bottom: 0,
      bg: "white"
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      bottom: 15
    }
  }, orderButton)));
};
var _default = Minicart;
exports.Z = _default;

/***/ }),

/***/ 57012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_Minicart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86525);
/* harmony import */ var _deosite_components_new_buttons_ButtonMinimalIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95574);
/* harmony import */ var _deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51586);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Minicart = function(props) {
    var propsExt = _objectSpread({}, props, {
        button: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonMinimalIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
        checkoutButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_4__["default"], {
            "data-test": "go-to-checkout"
        })
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_Minicart__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["default"] = (Minicart);


/***/ })

}]);